import React from "react";
import DataService from "../../helpers/DataService";

class CategoryInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      componentOpen: false,
      folderText: null,
    };
  }

  UNSAFE_componentWillMount() {
    DataService.getCategoryInfo(
      (jsonData) => {
        const text = jsonData.folder.description
          ? jsonData.folder.description
          : this.props.cmsData.noInformationText;
        this.setState({
          folderText: text,
        });
      },
      (error) => {
        this.setState({
          folderText: this.props.cmsData.noContactText,
        });
        console.error(error);
      },
      this.props.category.id
    );
  }

  _toggleComponent = (e) => {
    const open = e.target.classList.contains("open");
    this.setState({ componentOpen: !open });
  };

  render() {
    var folderText = this.state.folderText;
    return (
      <div
        className="row page-section section-gallery-category-info"
        id="gallery-category-info"
      >
        <div className="large-12 columns">
          <div className="big-toggler-trigger">
            <button
              type="button"
              onClick={this._toggleComponent}
              className={
                "reset icon-right " +
                (this.state.componentOpen
                  ? " icon-zoom-out open"
                  : " icon-zoom-in")
              }
            >
              {this.props.cmsData.buttonCategoryText}
            </button>
          </div>
          <div
            className={
              "gallery-category-info" +
              (this.state.componentOpen ? " open" : " closed")
            }
          >
            <div className="gallery-category-info-fade"></div>
            <div className="gallery-category-info-text">
              {folderText && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: folderText.replace(/(?:\r\n|\r|\\r\\n)/g, "<br />"),
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CategoryInfo;
